
<template id="simple-report-page">
  <section>
    <div class="row">
      <div class="col-md-10 col-lg-12 text-center mt-3 mb-5">
        <div class="card">
          <div class="card-header text-left">
            <i class="fa fa-file"></i> {{repTitle}}
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <div>
                <table width="100%">
                  <tr>
                    <th class="thead-dark" align="center" v-for="key in dimSelectDpValues" v-bind:key="key"> {{key}}</th>
                    <b>Generic Search</b>
                  </tr>
                  <tr>
                    <td v-for="(key,index) in dimSelectDpValues" v-bind:key="key">
                      <v-select multiple style="width: 100px;"  v-bind:key="key" v-model="selectVal[rowsDataDimKeys[index]]" :options="options[rowsDataDimKeys[index]]">

                        <!--<option value="">All</option>
                        <option style="width: 30px;" :value="option" v-for="option in options[rowsDataDimKeys[index]]" :key="option">{{ option }}</option>-->
                      </v-select>
                    </td>
                    <input type="text" v-model="filterValue" placeholder="Search">
                  </tr>
                </table>
              </div>
              <br>
              <div class="grid-container">
                <table class="table table-hover table-bordered">
                  <thead class="thead-dark" align="center">
                  <tr>
                    <th v-for="(col,index) in columns" v-bind:key="col">
                      {{col}}
                      <a href="#" @click="sortBy(Rcolumns[index])">
                        <i class="fa" v-bind:class="Rcolumns[index]===sortKey ? (sortOrder === 'asc' ?  'fa-sort-amount-down-alt' : 'fa-sort-amount-up-alt') : 'fa-sort' " v-bind:style="[Rcolumns[index]===sortKey ? {'color':'Gold'} : {'color':'White'}]" ></i>
                      </a>
                    </th>
                    <th>Action</th>
                    <th>Comment</th>
                    <th>Tag Status</th>
                    <th>Assign</th>
                  </tr>
                  </thead>
                  <tbody >
                  <tr v-for="(rowd,index) in filteredItems  " v-bind:key="index">
                    <td :class="{'text-right' : col.startsWith('rm'),'text-left' : col.startsWith('rd') || col.startsWith('rr'), 'text-danger':rowd['rm7']>40}" v-for="col in Rcolumns" v-bind:key="col">{{rowd[col]}}</td>
                    <td>
<!--                      <span @click="commentBox(rowd['rd1_id'])">
                      <i class="fa fa-lg fa-comments text-primary"></i>
                    </span>
                      <span @click="tagBox(rowd['rd1_id'])">
                        <i class="fa fa-tags text-primary" style="padding:5px"></i>
                      </span>
                      <span @click="assignBox(rowd['rd1_id'])">
                        <i class="fa fa-user-cog text-info" style="padding:1px"></i>
                      </span>-->

                       <span v-for="(ai,index) in currentMenuActionIconsData" :key="index">
          <span v-on:click="handleActionIconFunctionCall(ai.functionName,index,rowd['rd1l1_name'])">
              <i v-bind:id="ai.iconId"
                 v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                 :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                 style="font-size:15px; padding-left:10px; color:skyblue">
              </i>
          </span>
        </span>
                    </td>
                    <td><span v-if="rowd.comment==null">- NA -</span>
                      <span v-if="rowd.comment!=null">{{rowd.comment}}</span></td>
                    <td><span v-if="rowd.tag==null">- NA -</span>
                      <span v-if="rowd.tag!=null">{{rowd.tag}}</span></td>
                    <td><span v-if="rowd.assign==null">- NA -</span>
                      <span v-if="rowd.assign!=null">{{rowd.assign}}</span></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
          <b-form-group label="Comment">
            <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
          </b-form-group>
        </b-modal>

        <b-modal ref="tag-box" @ok="postTagging()" :title="tagTitle">
          <b-form-group label="Tagging">
            <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="OnTrack" v-model="picked"> OnTrack
            <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="RedFlag" v-model="picked"> RedFlag
            <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Validate" v-model="picked"> Validate

          </b-form-group>
          <b-form-group label="Comment">
            <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
          </b-form-group>
        </b-modal>

        <b-modal ref="assign-box" @ok="postAssign()" :title="tagTitle">
          <b-form-group label="Assign">
            <select v-model="assigned" >
              <!--<option value="Andy">Andy</option>
              <option value="Sarah">Sarah</option>
              <option value="Roger">Roger</option>
              <option value="Mark">Mark</option>
              <option value="Kane">Kane</option> -->
              <option v-for="ov in userData" :key="ov.userName" :value="ov.firstName"> {{ov.firstName}}</option>
            </select>
          </b-form-group>
          <b-form-group label="Comment">
            <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
          </b-form-group>
        </b-modal>

      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'

export default {
  name: 'simple-report-page',

  data: function() {
    return {
      output: [ ],
      repTitle:'',
      columns:[],
      keys: [ ],
      rowsdata: [ ],
      sortKey: [],
      sortOrder: ['asc'],
      dimSelectDpValues: [],
      rowsDataDimKeys: [],
      filterValue: '',
      cmnt: "",
      annotations: [],
      annotationTitle: "",
      picked:"",
      assigned:"",
      userData:{},
      tagTitle: "",
      iconOnChangeFlag: [],
      icons: [],
      levelicons: [],
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      }
    }
  },
  created: function () {
    //this.loadCustomerSales()
    this.loadReportConfig()
    this.listenToRouter()
  },
  computed: {
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      var intmdtColumns = Object.keys(this.rowsdata[0])
      var arr = intmdtColumns.filter(function (item) {
        if( item !== "assign")
          if ( item!=="comment")
            if(item!=="tag")
              return item
      })
      console.log("intrnmt columns",arr)
      return arr;
    },

    "orderedData": function () {
      let result=this.rowsdata;
      if (this.filterValue) {
        result = result.filter(item => item.rd2.includes(this.filterValue));
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    filteredItems() {
      let result = this.rowsdata.filter(item => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.rowsDataDimKeys.forEach(key => {

          if(this.selectVal[key]){
            // console.log("filter ", this.selectVal,this.selectVal[key].length==0)
            keep =
                keep &&
                (this.selectVal[key].length==0  ||
                    //item[key] === this.selectVal[key]); // true && (false ||
                    this.selectVal[key].includes(item[key])); // true && (false ||
          }

        });

        return keep;
      });
      if (this.filterValue) {
        /* Filters the report Data based on the entered value in the generic search box
           loop over the keys of the inner object and use Array.some()
           It will work for any number of keys of any name so no need to get depend on the keys
           to get the match of the searched text use includes()
           to make the search non case sensitive use toLowerCase()
           to avoid NULL values in filtering excluded null values by taking !=Null and with && operator
           Numeric values gave obj[key].includes is not function error so converted them to string using toString()
        */
        result = result.filter(obj =>
            Object.keys(obj)
                .some(key => (obj[key] != null ) && obj[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()))

        );


      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },

    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.rowsDataDimKeys.forEach(key => {
        const vals = this.rowsdata.map(item => item[key]);
        console.log("Options Data Vals",vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        console.log("Distinct Options Data ",options[key]);
      });

      return options;
    }
  },
  methods: {
    handleActionIconFunctionCall(fnName, index,x) {
      let val = !this.iconOnChangeFlag[index]
      this.$set(this.iconOnChangeFlag, index, val) //Array mutation happens only by set function or other mutation methods like slice,push,pop etc
      console.log("Handle function called with func name", fnName, this.iconOnChangeFlag,x)
      this[fnName](x)
    },
    downloadFile: function (file_name) {
      console.log(file_name, 'is the name')
      // window.location= `http://localhost:9888/${file_name}`
      window.location= `http://139.59.58.160:9888/${file_name}`
    },
    sortBy: function(key) {
      console.log("The sort Key is ",key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey=key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    commentBox: function (id) {
      let what = this.apiData.columns[0]
      console.log(
              `ENTERED into the commentBox function(${id},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
              this.annotationHeader + "->" + this.pg + "->" + this.section;
      this.$refs["comment-box"].show();
    },
    postAnnotation: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
      };
      axios.post(url, data).then(
              () => {
                // this.$store.dispatch("loadAnnotations");
                this.loadReportConfig()
              },
              (e) => {
                this.$commonFn.auditLog(menu, subMenu, "", "POST", e);
                console.error("error in updating annotations", e);
              }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

      this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success");
    },
    tagBox: function (id) {
      let what = this.apiData.columns[0]
      console.log(
              `ENTERED into the tagBox function(${id},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.tagHeader = "User Tagging";
      this.tagTitle =
              this.tagHeader + "->" + this.pg + "->" + this.section;
      this.$refs["tag-box"].show();
    },
    postTagging: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
        tagStatus: this.picked,
      };
      axios.post(url, data).then(
              () => {
                // this.$store.dispatch("loadAnnotations");
                this.loadReportConfig()
              },
              (e) => {
                this.$commonFn.auditLog(menu, subMenu, "", "POST", e);
                console.error("error in updating annotations", e);
              }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

      this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success");
    },
    assignBox: function (id) {
      let what = this.apiData.columns[0]
      console.log(
              `ENTERED into the assignBox function(${id},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.tagHeader = "User Assignment";
      this.tagTitle =
              this.tagHeader + "->" + this.pg + "->" + this.section;
      this.$refs["assign-box"].show();
      axios.get("/api/user").then(res => {
                this.userData = res.data
              },
              err => {
                console.log('Error Fetching data', err)
              })
    },
    postAssign: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
        assignedTo: this.assigned,
      };
      axios.post(url, data).then(
              () => {
                console.log("posting data",data)
                // this.$store.dispatch("loadAnnotations");
                this.loadReportConfig()
              },
              (e) => {
                this.$commonFn.auditLog(menu, subMenu, "", "POST", e);
                console.error("error in updating annotations", e);
              }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

      this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success");
    },

    //Get Request
    /*loadCustomerSales: function () {
      axios.get('/api/v_retailer_monthly')
        .then(res => {
          this.rowsdata = res.data
          console.log('Test', this.rowsdata)
        }, err => {
          console.log('Error fetching data', err)
        })
    },*/
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns= []
        setTimeout(() => {
          $this.loadReportConfig()
        }, 300)

      })
    },
    loadReportConfig: function () {
      console.info('loading summary')
      let menuParam = this.$route.params.submenuId
      //  let submenuParam = this.$route.params.submenuId

      console.log('sr','loading state');this.$store.dispatch("loadState").then(() => {

        let actionIconsData = this.$store.state.actionIcons
       // console.log("actions:", actionIconsData)

        //Get Request
        axios.get('/api/reportConfigColumn/' + menuParam)
            //           axios.get('/api/reportConfigColumn/'+ menuParam +'/'+submenuParam)
            .then(res => {
              this.apiData = res.data
              this.rowsdata = this.apiData.rowsData
              this.repTitle = this.apiData.columns[0].reportName
              this.icons = this.apiData.icons
              console.log("actions:", this.apiData,this.icons)

              //this.columns = this.apiData.columns
              this.columns = this.apiData.columns.map(function (el) {
                return el.headerColumnDisplay;
              })
              console.log('ReportConfigRes', this.apiData)
              var rowsDataKeys = Object.keys(this.rowsdata[0])
              this.rowsDataDimKeys = rowsDataKeys.filter(dim => dim.includes('d'))
              this.dimSelectDpValues = this.columns.slice(0, this.rowsDataDimKeys.length)
              console.log('Dimension variables Keys', this.rowsDataDimKeys)
              console.log('Data for Report', this.rowsdata)
              console.log('Dimension variables Keys', this.dimSelectDpValues)
              //console.log('Report Title',this.apiData.columns[0].repName)
              //console.log('Report headers',this.nameArray)
              this.levelicons = this.icons.filter(indi => indi.drilldownLevel == "level1")
              console.log('WC1:', this.icons, this.levelicons)

              var vizletActionIconsSyspkArray = this.levelicons[0].actionIconsSyspkArray ? this.levelicons[0].actionIconsSyspkArray : []
              // var vizletActionIconsSyspkArray = currentMenuData[0].vizletActionIconsSyspkArray ? currentMenuData[0].vizletActionIconsSyspkArray : []
              var currentMenuActionIconsData = actionIconsData.filter(r => vizletActionIconsSyspkArray.includes(r.syspk))
              console.log("welcome1:",currentMenuActionIconsData)

              // sort function for sorting the filtered currentMenuActionIconsData with the reference Array vizletActionIconsSyspkArray
              function sortFuncAI(a, b) {
                //console.log("test sort ", a,b,vizletActionIconsSyspkArray)
                return vizletActionIconsSyspkArray.indexOf(a.syspk) - vizletActionIconsSyspkArray.indexOf(b.syspk);
              }
              currentMenuActionIconsData.sort(sortFuncAI); //sorting the currentMenuActionIconsData
              this.currentMenuActionIconsData = currentMenuActionIconsData //need to add in router function
              this.iconOnChangeFlag = Array(this.currentMenuActionIconsData.length).fill(true);

            }, err => {
              console.log('Error Fetching data', err)
            })


        /*               //Get Request
                      axios.get('/api/reportConfigColumn/'+ menuParam +'/G01')
                      .then(res => {
                      this.drilldowndata = res.data
                      var columns = this.drilldowndata.columns
                      //var rowsdata = this.drilldowndata.rowsdata
                      console.log("API Response",this.drilldowndata)
                      var drilldownlevels = [...new Set(columns.map(dl => dl.drilldownLevel))] //... is the spread operator, which will expand the set values into an array.
                      var levelColumns = []
                      var headerColumns = []
                      for (var i=1; i<=drilldownlevels.length; i++)
                      {
                          var value ='level'+i
                          levelColumns[i] = columns.filter( ind => ind.drilldownLevel ==value)
                          headerColumns[i] = levelColumns[i].map(function (el) { return el.headerColumnDisplay;})
                      }
                      //this.headerColumnsDisplay = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
                      console.log("Drilldown data level1",headerColumns[1])
                      console.log("Drilldown data level2",headerColumns[2])
                      console.log("Drilldown data level3",headerColumns[3])

                      }, err => {
                      console.log('Error Fetching data', err)
                      })

                     //Post Request
                     const params = new URLSearchParams();
                     params.append('param1', 'value1');
                     params.append('param2', 'value2');
                     axios.post('/api/testparams', params)
                     //axios.post('/api/reportConfigColumn/'+ menuParam +'/G01')
                     .then(res => {
                      this.string = res.data
                     //var columns = this.drilldowndata.columns
                     //var rowsdata = this.drilldowndata.rowsdata
                     console.log("Post API Called",this.string)
                     }, err => {
                         console.log('Error Fetching data', err)
                         })
                 }*/
      })
    }
  }
}
</script>
<style scope>
th {
  font-size: 12px;
}
.grid-container {
  overflow-y: auto;
  height: 500px;
}
td  {
  text-align: left;
}
</style>